
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Tooltip from 'bootstrap/js/dist/tooltip'

import { onMounted, onUpdated, toRaw } from 'vue';

export default {
  name: "Socials",
  components: {
    ArgonInput,
    ArgonButton
  },
  props: {
    configuracao: {
      type: Object, // estava Array (provavelmente incorreto)
      default: () => ({})
    }
  },
    setup(props:any) {



      const initTooltips = () => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        tooltipTriggerList.forEach((el: any) => {
          if (!el._tooltip) {
            el._tooltip = new Tooltip(el)
          }
        })
      }

      onMounted(() => {
        initTooltips()
      })

      onUpdated(() => {
        initTooltips()
      })

      return {


        initTooltips
        
      };


    }
};
